document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-marquee-bar]').forEach((bar) => {
    const items = Array.from(bar.querySelectorAll('.marquee-bar__item'));
    if (items.length < 2) return;

    const interval = parseInt(bar.dataset.interval, 10) || 5000;
    const pauseOnHover = bar.dataset.pauseOnHover === 'true';
    let index = 0;
    let timer = null;

    const show = (nextIndex) => {
      items[index].classList.remove('is-active');
      items[index].setAttribute('aria-hidden', 'true');
      index = nextIndex;
      items[index].classList.add('is-active');
      items[index].removeAttribute('aria-hidden');
    };

    const start = () => {
      if (timer) return;
      timer = setInterval(() => {
        show((index + 1) % items.length);
      }, interval);
    };

    const stop = () => {
      clearInterval(timer);
      timer = null;
    };

    start();

    if (pauseOnHover) {
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
    }
  });

  document.querySelectorAll('[data-open-modal]').forEach((trigger) => {
    const modal = document.getElementById(trigger.dataset.openModal);
    if (!modal) return;

    trigger.addEventListener('click', () => {
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
    });

    modal.querySelectorAll('[data-close-modal]').forEach((closeButton) => {
      closeButton.addEventListener('click', () => modal.close());
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) modal.close();
    });
  });

  document.querySelectorAll('.marquee-modal__select').forEach(enhanceSelect);
});

/*
  Language / country lists drawn by the theme instead of the browser's native
  dropdown (Firefox highlights only part of the row on hover). The real
  <select> stays in the form, hidden, and keeps the value that is submitted.
*/
function enhanceSelect(select) {
  const wrapper = select.closest('.marquee-modal__select-wrapper');
  if (!wrapper) return;
  const modal = select.closest('dialog');
  const label = document.querySelector(`label[for="${select.id}"]`);

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'marquee-modal__select marquee-modal__select--custom';
  button.setAttribute('aria-haspopup', 'listbox');
  button.setAttribute('aria-expanded', 'false');
  if (label) {
    label.id = label.id || `${select.id}-label`;
    button.setAttribute('aria-labelledby', `${label.id} ${select.id}-button`);
    label.htmlFor = `${select.id}-button`;
  }
  button.id = `${select.id}-button`;

  const list = document.createElement('ul');
  list.className = 'marquee-modal__options';
  if (select.hasAttribute('data-opens-up')) list.classList.add('marquee-modal__options--up');
  list.setAttribute('role', 'listbox');
  list.tabIndex = -1;
  list.hidden = true;

  const options = Array.from(select.options).map((option, index) => {
    if (option.hasAttribute('data-divider')) {
      // Line between the most-ordered countries and the full list.
      const divider = document.createElement('li');
      divider.className = 'marquee-modal__divider';
      divider.setAttribute('role', 'separator');
      list.appendChild(divider);
      return null;
    }
    const item = document.createElement('li');
    item.className = 'marquee-modal__option';
    item.setAttribute('role', 'option');
    item.id = `${select.id}-option-${index}`;
    item.textContent = option.textContent.trim();
    if (option.lang) item.lang = option.lang;
    item.addEventListener('click', () => {
      choose(index);
      close(true);
    });
    item.addEventListener('mousemove', () => setActive(index, false));
    list.appendChild(item);
    return item;
  });

  let active = select.selectedIndex;

  const render = () => {
    button.textContent = select.options[select.selectedIndex]?.textContent.trim() || '';
    options.forEach((item, index) => item?.setAttribute('aria-selected', String(index === select.selectedIndex)));
  };

  // step: direction to move past the divider when landing on it.
  const setActive = (index, scroll = true, step = 1) => {
    active = Math.max(0, Math.min(options.length - 1, index));
    if (!options[active]) active = Math.max(0, Math.min(options.length - 1, active + step));
    options.forEach((item, i) => item?.classList.toggle('is-active', i === active));
    list.setAttribute('aria-activedescendant', options[active].id);
    if (scroll) options[active].scrollIntoView({ block: 'nearest' });
  };

  const choose = (index) => {
    if (select.selectedIndex !== index) {
      select.selectedIndex = index;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    render();
  };

  const open = () => {
    list.hidden = false;
    modal?.classList.add('has-open-list');
    if (list.classList.contains('marquee-modal__options--up')) {
      // Never taller than the room above the field (short laptop screens).
      list.style.maxHeight = `${Math.max(160, Math.min(280, button.getBoundingClientRect().top - 16))}px`;
    }
    button.setAttribute('aria-expanded', 'true');
    setActive(select.selectedIndex);
    list.focus({ preventScroll: true });
  };

  const close = (focusButton) => {
    if (list.hidden) return;
    list.hidden = true;
    modal?.classList.remove('has-open-list');
    button.setAttribute('aria-expanded', 'false');
    if (focusButton) button.focus();
  };

  button.addEventListener('click', () => (list.hidden ? open() : close(true)));
  button.addEventListener('keydown', (event) => {
    if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) {
      event.preventDefault();
      open();
    }
  });

  let typed = '';
  let typedTimer = null;
  list.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowDown') setActive(active + 1);
    else if (event.key === 'ArrowUp') setActive(active - 1, true, -1);
    else if (event.key === 'Home') setActive(0);
    else if (event.key === 'End') setActive(options.length - 1);
    else if (event.key === 'Enter' || event.key === ' ') {
      choose(active);
      close(true);
    } else if (event.key === 'Escape' || event.key === 'Tab') {
      close(event.key === 'Escape');
      if (event.key === 'Tab') return;
    } else if (event.key.length === 1) {
      // Type-ahead: jump to the first entry starting with the typed letters.
      typed += event.key.toLowerCase();
      clearTimeout(typedTimer);
      typedTimer = setTimeout(() => (typed = ''), 600);
      const found = options.findIndex((item) =>
        item &&
        item.textContent.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().startsWith(typed)
      );
      if (found !== -1) setActive(found);
    } else return;
    event.preventDefault();
  });

  // Escape closes the list first, not the whole dialog.
  modal?.addEventListener('cancel', (event) => {
    if (!list.hidden) {
      event.preventDefault();
      close(true);
    }
  });

  document.addEventListener('click', (event) => {
    if (!wrapper.contains(event.target)) close(false);
  });
  modal?.addEventListener('close', () => close(false));

  select.classList.add('marquee-modal__native');
  select.tabIndex = -1;
  select.setAttribute('aria-hidden', 'true');
  wrapper.insertBefore(button, select);
  wrapper.appendChild(list);
  render();
}
